import React, { JSX } from 'react';
import { TranslationKey } from './../../../../types/translation/TranslationKey';
import { t } from '../../../../types/translation/Translator';
import { StockLocation } from '../../../../types/stock_location/stockLocation';
import { ListIcon } from '../../../icons/List/ListIcon';
import { OrderStatusFilterDropdownContent, OrderStatusFilterInnerContent } from './DropdownContent';
import { BaseFilter, BaseFilterProps } from '../common/BaseFilter';
import { OrderStatus, OrderUtil } from '../../../../types/order';
import { itemsContainText } from '../../../../util/string.util';
import { TableSettings } from '../../../../types/table_settings/TableSettings';

export class OrderStatusFilter extends BaseFilter<OrderStatus> {
  stockLocations: Map<string, StockLocation>;
  tableSettings: TableSettings<any>;

  constructor(stockLocations: Map<string, StockLocation>, tableSettings: TableSettings<any>) {
    super();
    this.stockLocations = stockLocations;
    this.tableSettings = tableSettings;
  }

  toLabel(): string {
    return t(TranslationKey.orderStatus).singular.label;
  }

  toCount(props: BaseFilterProps): number {
    return props.filterProps.orderStatus?.size || 0;
  }

  toIcon(): JSX.Element {
    return <ListIcon className={this.className} />;
  }

  search(item: OrderStatus, query: string): boolean {
    return itemsContainText(query, [item, OrderUtil.statusToString(item)]);
  }

  toDropdownContent(props: BaseFilterProps): JSX.Element {
    return (
      <OrderStatusFilterDropdownContent
        filter={this}
        filterProps={props.filterProps}
        setFilterProps={props.setFilterProps}
      />
    );
  }

  toInnerContent(props: BaseFilterProps): string | JSX.Element {
    return (
      <OrderStatusFilterInnerContent
        filter={this}
        filterProps={props.filterProps}
        setFilterProps={props.setFilterProps}
      />
    );
  }
}
